module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "promote-modal-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "main-section text-left",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('h2', {
    staticClass: "page-title text-xs-left"
  }, [_vm._v("Promote")]), _vm._v(" "), _c('div', {
    staticClass: "normal-tab"
  }, [_c('v-tabs', {
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-item', {
    key: "suggested",
    attrs: {
      "href": "#suggested",
      "ripple": ""
    }
  }, [_vm._v("Suggested Reposters")]), _vm._v(" "), _c('v-tabs-item', {
    key: "current",
    attrs: {
      "href": "#current",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getCurrentReposters()
      }
    }
  }, [_vm._v("Current Reposters")]), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "black"
    }
  })], 1), _vm._v(" "), (_vm.tab == 'suggested') ? _c('v-layout', {
    staticClass: "search-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.repost_prices,
      "item-text": "title",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.repost_price),
      callback: function($$v) {
        _vm.repost_price = $$v
      },
      expression: "repost_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.amounts,
      "item-text": "title",
      "item-value": "value",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filters,
      "item-text": "title",
      "item-value": "value",
      "label": "Category",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search Username"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "mx-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "search-btn",
    nativeOn: {
      "click": function($event) {
        _vm.searchUsers()
      }
    }
  }, [_vm._v("Search")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "suggested",
    attrs: {
      "id": "suggested"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left pl-2",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left px-2",
    attrs: {
      "sm3": ""
    }
  }, [_vm._v("Recent Reposts")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-section"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "suggested-reposter-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "user-avatar",
      style: (("background-image: url(" + (user.avatar.thumb.url) + ")"))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-name text-xs-left pl-2"
    }, [_vm._v("\n                        " + _vm._s(user.username) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-followers"
    }, [_vm._v(_vm._s(user.followers))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "repost-price"
    }, [_vm._v("\n                        $" + _vm._s(_vm._f("formatNumber")(user.repost_price)) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "recent-posts text-xs-left px-2"
    }, _vm._l((user.recent_items), function(recent_item, index) {
      return _c('div', {
        key: index,
        staticClass: "recent-post-item"
      }, [(recent_item.assoc_type == 'Album') ? _c('activity-album-card', {
        attrs: {
          "object": recent_item.assoc
        }
      }) : _vm._e(), _vm._v(" "), (recent_item.assoc_type == 'ShopProduct') ? _c('activity-product-card', {
        attrs: {
          "object": recent_item.assoc,
          "price-show": false
        }
      }) : _vm._e()], 1)
    }))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('v-btn', {
      staticClass: "select-btn",
      class: {
        selected: _vm.user_ids.indexOf(user.id) > -1
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(user)
        }
      }
    }, [_vm._v("Select User")])], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "total-section"
  }, [_c('v-btn', {
    staticClass: "finish-btn ml-3 mt-1",
    nativeOn: {
      "click": function($event) {
        _vm.saveAndFinish()
      }
    }
  }, [_vm._v("Finish & Pay")]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Potential Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.suggested_values.total_potential_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Cost")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      $" + _vm._s(_vm._f("formatNumber")(_vm.suggested_values.total_cost)) + "\n                    ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "current",
    attrs: {
      "id": "current"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left pl-2",
    attrs: {
      "sm3": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Price")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title text-xs-left px-2",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Actual Reach(Plays)")]), _vm._v(" "), _c('v-flex', {
    staticClass: "header-title",
    attrs: {
      "sm2": ""
    }
  }, [_vm._v("Add to favorites")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-section current"
  }, _vm._l((_vm.reposters), function(user, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "suggested-reposter-item",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "user-avatar",
      style: (("background-image: url(" + (user.avatar.thumb.url) + ")"))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm3": ""
      }
    }, [_c('p', {
      staticClass: "user-name text-xs-left pl-2"
    }, [_vm._v("\n                        " + _vm._s(user.username) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "user-followers"
    }, [_vm._v(_vm._s(user.followers))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [_c('p', {
      staticClass: "repost-price"
    }, [_vm._v("\n                        $" + _vm._s(_vm._f("formatNumber")(user.repost_price)) + "\n                      ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": ""
      }
    }, [(_vm.favorite_ids.indexOf(user.id) > -1) ? _c('v-btn', {
      staticClass: "favorite-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addUserToFavorite(user)
        }
      }
    }, [_c('v-icon', [_vm._v("favorite")])], 1) : _vm._e(), _vm._v(" "), (_vm.favorite_ids.indexOf(user.id) < 0) ? _c('v-btn', {
      staticClass: "favorite-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addUserToFavorite(user)
        }
      }
    }, [_c('v-icon', [_vm._v("favorite_border")])], 1) : _vm._e()], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "total-section"
  }, [_c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Paid")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      $" + _vm._s(_vm._f("formatNumber")(_vm.current_values.total_paid)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Potential Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.current_values.total_potential_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "cost-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Total Actual Reach")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("\n                      " + _vm._s(_vm.current_values.total_actual_reach) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "total-potential-section px-3"
  }, [_c('p', {
    staticClass: "title mb-1"
  }, [_vm._v("Score")]), _vm._v(" "), _c('p', {
    staticClass: "value"
  }, [_vm._v("0%")])])])], 1)], 1)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146fb58c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotemodal.vue
// module id = 1618
// module chunks = 180